import { Paper } from '@atgfr8/atg-ui-tailwind';
import { AlertIcon } from '@atgfr8/icons';
import { carrierStore } from '@store/orders';

export const MatchedBanner = () => {
  return (
    <Paper elevation={4} class="mb-2 border-[3px] border-[#f59d25]">
      <div class="flex items-center p-4 gap-x-4">
        <AlertIcon color="#f59d25" />
        <div class="text-sm font-medium">{`Please review the information for ${carrierStore.carrier[0]?.name}
             and click "Save" to ensure your Load is covered. Any unsaved changes will be lost if you leave this page.
            `}</div>
      </div>
    </Paper>
  );
};
